import PerfectScrollbar from 'react-perfect-scrollbar';
import { FileManagerColumns } from '../../components/files/file-manager-colums.jsx';
import { FileManagerFolderMain, FileManagerFileMain } from '../../components/files/file-manager-folder.jsx';
import { arrayAny } from '../../utils/arrayUtils.js';

export const FileManagerMainWindow = ({ data, setPath, getImage, setShowPreviousModal, showCheckboxes, selectedItems, setSelectedItems }) => {
    
    const handleAddToSelectedItems = (item) => {
        setSelectedItems(item);
    };

    const itemSelected = (item) => {
        const existingEntry = selectedItems ? selectedItems[item.path] : null;
        return existingEntry != null;
    };

    return (
        <div className="flex-1 overflow-hidden">
            <PerfectScrollbar className="h-100 p-0" options={{ suppressScrollX: true }}>
                <table className="table table-striped table-borderless table-sm m-0 text-nowrap">
                    <FileManagerColumns showCheckboxes={showCheckboxes} showVersions={true} />
                    <tbody>
                        {arrayAny(data) && data.map((item, i) => {
                            return item.isFolder ?
                                <FileManagerFolderMain
                                    key={`folder-${i}-${item.name}`}
                                    setPath={setPath}
                                    getImage={getImage}
                                    folder={item}
                                    showCheckboxes={showCheckboxes}
                                    setSelected={handleAddToSelectedItems}
                                    selected={itemSelected(item)}
                                />
                                :
                                <FileManagerFileMain
                                    key={`file-${i}-${item.name}`}
                                    file={item}
                                    getImage={getImage}
                                    setShowPreviousModal={setShowPreviousModal}
                                    showingModal={false}
                                    showCheckboxes={showCheckboxes}
                                    setSelected={handleAddToSelectedItems}
                                    selected={itemSelected(item)}
                                />
                        })}
                    </tbody>
                </table>
            </PerfectScrollbar>
        </div>
    );
};